export default __webpack_public_path__ + "static/media/Group 3032.9dcbf44a.png";